import { INSIGHTS_BILL_ANALYSIS_ACTIONS } from '../../actions/insightsBillAnalysisActions';
import { INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS } from '../../dataFetchers/insightsPageDataFetcher'

export const defaultState = {
    billStart: 0,
    compareBillStart: 0,
    currentBillingCycle1: '',
    currentBillingCycle2: '',
    billAmountCurrent: '',
    billAmountPrev: '',
    billAmountIncreased: 0,
    billChangeReasons: [],
    billAnalysisLeftBoundary: false,
    billAnalysisRightBoundary: false,
    isBillAnalysisLoading: true,
    billAnalysisDataNotAvailable: false,
    apiError: null
};

export const insightsBillAnalysisReducer = (state = {
    ...defaultState
}, action) => {
    switch (action.type) {
        case INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.FETCH_USAGE_BILL_ANALYSIS_DATA :{
            let data = action.payload.data.payload;
            state = {
                ...state,
                currentBillingCycle1: data.billCycleDetails && data.billCycleDetails.intervalStartDate,
                currentBillingCycle2: data.billCycleDetails && data.billCycleDetails.intervalEndDate,
                billAmountCurrent: data.billCycleDetails && data.billCycleDetails.cost,
                billAmountPrev: data.comparedBillCycleDetails && data.comparedBillCycleDetails.cost,
                billAmountIncreased: data.billCycleDetails && data.comparedBillCycleDetails && data.billCycleDetails.cost - data.comparedBillCycleDetails.cost,
                billChangeReasonSummary: data.billAnalysis.summary,
                billChangeReasons: data.billAnalysis.billChangeReasons,
                billAnalysisRightBoundary: data.billCycleDetails && data.billCycleDetails.boundaryCycle,
                billAnalysisLeftBoundary: data.comparedBillCycleDetails && data.comparedBillCycleDetails.boundaryCycle,
                billStart: data.billCycleDetails && data.billCycleDetails.intervalStart,
                compareBillStart: data.comparedBillCycleDetails && data.comparedBillCycleDetails.intervalStart,
                isBillAnalysisLoading: false,
                billAnalysisDataNotAvailable: !!!data.billCycleDetails && !!!data.comparedBillCycleDetails,
                apiError: null
            };
            break;
        }
        case INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.ERROR_USAGE_BILL_ANALYSIS_DATA: {
            state = {
                ...state,
                billAmountCurrent: 100,
                billAmountPrev: 100,
                apiError: true,
                isBillAnalysisLoading: false
            }
            break;
        }
        case INSIGHTS_BILL_ANALYSIS_ACTIONS.CHANGE_USAGE_BILL_ANALYSIS_DATA: {
            state = {
                ...state,
                ...action.payload
            };
            break;
        }
        default: 
            break;
    }
    return state;
}